<script setup>
/** 对局逐回合回放；被改编成场次的回合高亮并链到下方对应的分镜卡。 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import BeatText from './BeatText.vue'

const props = defineProps({
  run: { type: Object, required: true },
  sceneNoByTurn: { type: Map, required: true },
})

const { t } = useI18n()

/** 开场的几句合成一条，玩家回合各自一条。 */
const beats = computed(() => {
  const list = []
  for (const entry of props.run.transcript) {
    const last = list.at(-1)
    if (entry.speaker === 'narrator' && last?.opening) {
      last.entries.push(entry)
      continue
    }
    list.push({ turn: entry.turn, opening: entry.speaker === 'narrator', entries: [entry] })
  }
  return list
})
</script>

<template>
  <ol class="transcript-timeline">
    <li
      v-for="beat in beats"
      :key="beat.opening ? 'opening' : beat.turn"
      :class="['transcript-timeline__beat', { 'is-scened': !beat.opening && sceneNoByTurn.has(beat.turn) }]"
    >
      <span class="transcript-timeline__turn">
        {{ beat.opening ? t('visualGameAdmin.generationRecords.process.transcript.opening') : beat.turn }}
      </span>
      <div class="transcript-timeline__body">
        <BeatText v-for="(entry, index) in beat.entries" :key="index" :entry="entry" />
      </div>
      <a v-if="!beat.opening && sceneNoByTurn.has(beat.turn)" :href="`#scene-${sceneNoByTurn.get(beat.turn)}`" class="transcript-timeline__link">
        {{ t('visualGameAdmin.generationRecords.process.transcript.toScene', { scene: sceneNoByTurn.get(beat.turn) }) }}
      </a>
    </li>
    <li v-if="run.ending_id" class="transcript-timeline__beat is-ending">
      <span class="transcript-timeline__turn">{{ t('visualGameAdmin.generationRecords.process.transcript.ending') }}</span>
      <div class="transcript-timeline__body">
        <p><strong>{{ run.ending_title ?? run.ending_id }}</strong></p>
        <p v-if="run.ending_description">{{ run.ending_description }}</p>
      </div>
    </li>
  </ol>
</template>

<style scoped>
.transcript-timeline {
  margin: 0;
  padding: 0;
  list-style: none;
}

.transcript-timeline__beat {
  display: grid;
  grid-template-columns: 56px 1fr auto;
  gap: var(--drama-space-md);
  padding: var(--drama-space-md);
  border-left: 3px solid transparent;
  font-size: var(--drama-font-size-sm);
}

.transcript-timeline__beat + .transcript-timeline__beat {
  border-top: 1px solid var(--drama-color-border);
}

.transcript-timeline__beat.is-scened {
  border-left-color: var(--drama-color-info);
  background: color-mix(in srgb, var(--drama-color-info) 6%, transparent);
}

.transcript-timeline__beat.is-ending {
  border-left-color: var(--drama-color-warning);
}

.transcript-timeline__turn {
  color: var(--drama-color-text-muted);
  font-family: var(--drama-font-family-mono);
  font-size: var(--drama-font-size-xs);
  line-height: 1.6;
}

.transcript-timeline__body {
  display: flex;
  flex-direction: column;
  gap: var(--drama-space-xs);
  min-width: 0;
}

.transcript-timeline__body p {
  margin: 0;
  line-height: 1.6;
}

.transcript-timeline__link {
  align-self: start;
  color: var(--drama-color-info);
  font-size: var(--drama-font-size-xs);
  white-space: nowrap;
}
</style>
